export class WebCodeCheck {
    private resultsCallback: (data: any) => void = () => { };
    private errorCallback: (request: any, status: any, error: any) => void = () => { };

    constructor(selector) {
        const $select = $(selector);
        const searchUrl = $select.data("check-unique-code");
        $(selector).on("blur", (e) => {
            const code = e.target.value;
            this.checkCode(searchUrl, code);
        });
    }

    private checkCode(url, code) {
        $.ajax({
            url: url,
            data: {
                "UniqueCode": code
            }
        }).done((data) => {
            this.processResults(data);
        }).fail((request, status, error) => {
            this.processError(request, status, error);
        });
    }

    private processResults(data: any) {
        // Run any success methods here before user provided callback
        this.resultsCallback(data);
    }

    private processError(request: any, status: any, error: any) {
        // Run any error methods here before user provided callback
        this.errorCallback(request, status, error);
    }

    onComplete(callback: (data: any) => void): WebCodeCheck {
        this.resultsCallback = callback;
        return this;
    }

    onError(callback: (request: any, status: any, error: any) => void): WebCodeCheck {
        this.errorCallback = callback;
        return this;
    }
}